"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargebeeRepository = void 0;
class ChargebeeRepository {
    constructor(client) {
        this.clientWithRetry = client.clientWithRetry;
        this.clientWithoutRetry = client.clientWithoutRetry;
    }
    createSource(chargebeeId, city, country, email, firstName, iban, lastName, line1, postalCode) {
        return __awaiter(this, void 0, void 0, function* () {
            // With this we ensure correct data structure, no matter where the call comes from
            const { data } = yield this.clientWithoutRetry.post(`/chargebee_sources/${chargebeeId}`, {
                billingAddress: { city, country, email, line1, postalCode },
                chargebeeId,
                firstName,
                iban,
                lastName,
            });
            return data;
        });
    }
    updateBillingInformations(organisationId, billingInformations, token) {
        return __awaiter(this, void 0, void 0, function* () {
            // With this we ensure correct data structure, no matter where the call comes from
            const { data } = yield this.clientWithoutRetry.put(`/chargebee_sources/${organisationId}/bulk_update`, {
                billingInformations: billingInformations,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return data;
        });
    }
    getSources(chargebeeIds, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const encodedChargebeeIds = encodeURIComponent(chargebeeIds.join(','));
            const { data } = yield this.clientWithRetry.get(`/chargebee_sources?chargebeeIds=${encodedChargebeeIds}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return data;
        });
    }
}
exports.ChargebeeRepository = ChargebeeRepository;
//# sourceMappingURL=ChargebeeRepository.js.map